import { tagSchema as o } from "@scalar/oas-utils/entities/spec";
import { schemaModel as T } from "@scalar/oas-utils/helpers";
import { LS_KEYS as p } from "@scalar/helpers/object/local-storage";
import { mutationFactory as A } from "@scalar/object-utils/mutator-record";
import { reactive as g } from "vue";
function L(d) {
  const a = g({}), s = A(a, g({}), d && p.TAG);
  return {
    tags: a,
    tagMutators: s
  };
}
function q({
  collectionMutators: d,
  collections: a,
  requests: s,
  requestMutators: c,
  tagMutators: m
}) {
  return { addTag: (t, n) => {
    const r = a[n], e = T(t, o, !1);
    return !e || !r ? console.error("INVALID TAG DATA", t) : (d.edit(n, "tags", [...r.tags, e.uid]), d.edit(n, "children", [...r.children, e.uid]), m.add(e), e);
  }, deleteTag: (t, n) => {
    const r = a[n];
    r && (d.edit(
      n,
      "tags",
      r.tags.filter((e) => e !== t.uid)
    ), d.edit(
      n,
      "children",
      r.children.filter((e) => e !== t.uid)
    ), t.children.forEach((e) => {
      var u;
      const f = s[e];
      if (!f)
        return;
      const i = (u = f.tags) == null ? void 0 : u.filter((h) => h !== t.name);
      c.edit(f.uid, "tags", i), !(i != null && i.length) && !r.children.includes(e) && d.edit(n, "children", [...r.children, e]);
    }), m.delete(t.uid));
  } };
}
export {
  L as createStoreTags,
  q as extendedTagDataFactory
};
